// frontend/src/pages/AuthError.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Alert, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';import { useThemeSettings } from "../contexts/ThemeContext";

function AuthError() {const { t } = useThemeSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Get error details from URL
  const errorType = searchParams.get('error') || 'unknown_error';
  const errorDescription = searchParams.get('description') || 'An unknown error occurred during authentication';

  // Get user-friendly error message based on error type
  const getUserFriendlyMessage = (type) => {
    switch (type) {
      case 'consent_required':
        return 'You need to grant permission to access your Microsoft account. Please try again and accept the permissions.';
      case 'tenant_not_approved':
        return 'Your organization is not authorized to use this application. Please contact support for more information.';
      case 'no_code':
        return 'No authorization code was received from Microsoft. Please try again or contact support.';
      case 'no_token':
        return 'No authentication token was received. Please try again or contact support.';
      case 'token_error':
        return 'There was a problem obtaining an authentication token. Please try again later.';
      case 'server_error':
        return 'An unexpected server error occurred. Please try again later or contact support.';
      default:
        return 'An authentication error occurred. Please try again or contact support.';
    }
  };

  const friendlyMessage = getUserFriendlyMessage(errorType);

  return (
    <Box
      className="page-transition-enter"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        backgroundColor: (theme) => theme.palette.background.default
      }}>

      <Paper
        elevation={3}
        className="card-animated card-enter"
        sx={{
          maxWidth: 500,
          width: '100%',
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        
        <ErrorOutlineIcon color="error" className="pulse" sx={{ fontSize: 60, mb: 2 }} />

        <Typography variant="h5" className="slide-down" sx={{ mb: 2, textAlign: 'center' }}>{t ? t("AuthError.authentication_failed") : "Authentication Failed"}

        </Typography>

        <Alert severity="error" className="slide-up" sx={{ width: '100%', mb: 3 }}>
          {friendlyMessage}
        </Alert>
        
        {process.env.NODE_ENV === 'development' &&
        <Box sx={{ mb: 3, width: '100%' }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>{t ? t("AuthError.technical_details_development_only") : "Technical Details (Development Only):"}

          </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>{t ? t("AuthError.error") : "Error:"}
            {errorType}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>{t ? t("SolutionVerification.description") : "Description:"}
            {errorDescription}
            </Typography>
          </Box>
        }
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/login')}>{t ? t("AuthCallback.return_login") : "Return to Login"}


          </Button>
          
          <Button
            variant="outlined"
            onClick={() => window.location.href = 'http://api.caro.care/api/auth/microsoft'}>{t ? t("LocationManagement.try_again") : "Try Again"}


          </Button>
        </Box>
      </Paper>
    </Box>);

}

export default AuthError;